import React from "react";
import "./AboutPage.css";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../api/client";

import about1 from "../../Assets/About/about-1.jpg";
import { STORE_PHONE_PRIMARY, STORE_PHONE_ALT } from "../../constants/storeContact";

const STORE_ADDRESS =
  "GEM House, 5/54, RSC-2, Four Bungalows, Mhada Rd, SV Patel Nagar, Andheri West, Mumbai, Maharashtra 400053";
const STORE_EMAIL = "gemboutiqueinquiries@gmail.com";

/** Served from backend static `/uploads` (see `backend/uploads/gemhouse.webp`). */
const GEM_HOUSE_IMAGE = getImageUrl("/uploads/gemhouse.webp");

const AboutPage = () => {
  return (
    <>
      <div className="aboutSection">
        <h2>About Gem Fashion Studios</h2>
        <img src={about1} alt="Gem Fashion Studios boutique and designer rental styling" />
        <div className="aboutContent">
          <h3>Our Story</h3>
          <p className="aboutLead">
            Gem Fashion Studios is a Mumbai-based boutique focused on curated designer and occasion-ready
            looks—primarily on <strong>rent</strong>. We help you dress for weddings, festive gatherings,
            receptions, and special moments without the commitment of buying pieces you may wear once.
          </p>
          <p>
            From sherwanis and suits to lehengas, sarees, Indo-western sets, dresses, and more, our catalogue
            is built around quality silhouettes and finishes. Browse by collection—mens, womens, festive, or
            occasion—or explore the full rentals shop online. Prefer to chat through sizing, timelines, or
            styling? Our team is a call or email away.
          </p>
          <div className="content1">
            <div className="contentBox">
              <h5>Our Mission</h5>
              <p>
                To make standout occasion wear accessible through reliable rental—from accurate listings and
                transparent pricing (including secure checkout) to helpful service when you need it.
              </p>
            </div>
            <div className="contentBox">
              <h5>Our Vision</h5>
              <p>
                To be the boutique customers trust when they want to look polished and feel confident across
                every celebration—backed by a thoughtful catalog and seamless online experience.
              </p>
            </div>
          </div>
          <div className="content2">
            <div className="imgContent">
              <img src={GEM_HOUSE_IMAGE} alt="GEM House storefront, Gem Fashion Studios Andheri West" />
            </div>
            <div className="textContent">
              <h5>The Company</h5>
              <p>
                We operate from <strong>{STORE_ADDRESS}</strong>, serving inquiries and pickups as coordinated
                with our team. You can explore inventory on this site anytime; for bespoke questions—dates,
                fit, alterations, or availability—please reach out and we&apos;ll guide you through the next
                steps.
              </p>
              <div className="aboutContact" role="note">
                <strong>Get in touch</strong>
                <br />
                <a href={`mailto:${STORE_EMAIL}`}>{STORE_EMAIL}</a>
                <br />
                <a href={`tel:${STORE_PHONE_PRIMARY.tel}`}>{STORE_PHONE_PRIMARY.display}</a>
                <br />
                <a href={`tel:${STORE_PHONE_ALT.tel}`}>{STORE_PHONE_ALT.display}</a>
              </div>
              <div className="aboutActions">
                <Link to="/shop" className="aboutActionsPrimary">
                  Browse rentals
                </Link>
                <Link to="/contact">Contact us</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
